import React, {FC, useEffect} from "react";
import {Accordion} from "react-bootstrap";
import QuickbetXLobbyWidget from "./QuickbetXLobbyWidget";
import JackpotLobbyWidget from "./JackpotLobbyWidget";
import SmartbetLobbyWidget from "./SmartbetLobbyWidget";
import SuperbetLobbyWidget from "./SuperbetLobbyWidget";
import './LobbyWidget.css';

interface LobbyWidget {
    atagParams: string | null,
    types?: number[] | null,
    sourceParams: string | null,
}
const LobbyWidget: FC  <LobbyWidget>  = ({atagParams, types, sourceParams}) => {
    const shouldRenderAll = types && types.length === 0;

    useEffect(() => {
        const sendHeight = () => {
            const height = document.body.scrollHeight;

            window.parent.postMessage(
                {
                    type: "SET_IFRAME_HEIGHT",
                    height
                },
                "*"
            );
        };

        sendHeight();
        const observer = new ResizeObserver(() => {
            sendHeight();
        });

        observer.observe(document.body);

        return () => {
            observer.disconnect();
        };
    }, []);
    return (
        <div className="betting-tips-card">
            <div className="betting-tips-header">
                <p className="betting-tips-title">Betting Tips</p>
            </div>

            <hr className="betting-tips-divider"/>
            <Accordion
                defaultActiveKey="0"
                flush
                className="betting-tips-accordion"
            >
                <SmartbetLobbyWidget atagParams={atagParams} sourceParams={sourceParams} mode="iframe"/>
                <JackpotLobbyWidget atagParams={atagParams} sourceParams={sourceParams} mode="iframe"/>
                <QuickbetXLobbyWidget atagParams={atagParams} sourceParams={sourceParams} mode="iframe"/>
                <SuperbetLobbyWidget  atagParams={atagParams} sourceParams={sourceParams} mode="iframe"/>
            </Accordion>
        </div>
    );
};

export default LobbyWidget;
